import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import mainSelectors from "../modules/main/selectors";

const withUserPerm = (Component, page = undefined) => {
  const User = (props) => {
    console.log("props", props);
    const currentAd = useSelector((state) => mainSelectors.currentAd(state));
    const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));
    let history = useHistory();
    const checkAdsId = currentAd.ads_account_id;
    console.log("history.location.pathname", history.location.pathname);
    console.log("currentAd", currentAd);
    console.log("authAdproResult", authAdproResult);
    const checkWizard = history.location.pathname === "/wizard" ? authAdproResult.data.allAds : false;
    if (checkWizard) {
      console.log("wizard permission passed");
      return <Component {...props} />;
    } else if (checkAdsId || authAdproResult.result === 1 || authAdproResult.result === 2) {
      console.log("permission passed");
      return <Component {...props} />;
    } else {
      console.log("permission error go loading", currentAd.ads_account_id);
      history.replace("/");
      return null;
    }
  };
  return User;
};

const enchancedWithUserPerm = (page) => {
  return (Component) => withUserPerm(Component, page);
};

export default enchancedWithUserPerm;
